import HorizontalFoldingSlider from "components/horizontalFoldingSlider/HorizontalFoldingSlider";
import { Typography } from "design_system/src";
import React from "react";
import HeadquarterItem, { HeadquarterItemProps } from "./HeadquarterItem";


const headquartersItems: HeadquarterItemProps[] = [
  {
    title: "Sede Anáhuac",
    subtitle: "Oficina principal",
    address: "Laguna de Mayran 396, Anáhuac I Secc., Anáhuac I Secc, Miguel Hidalgo, 11320 Ciudad de México, CDMX, México.",
    googleMapsLink: "https://maps.app.goo.gl/hWWWDqwB8d58h3ih7",
    imageUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Mobile/conoce_nuestras_sedes_anahuac_financiamiento_facil_small",
    desktopImageUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Desktop/conoce_nuestras_sedes_financiamiento_facil",
    dekstopLineUrl: "https://ik.imagekit.io/ozon/Homepage/im%C3%A1genes/Desktop/conoce_nuestras_sedes_financiamiento_facil_linea_1",
    imageAlt: "Oficina principal de Ozon en Ciudad de México",
  },
];

const Headquarters: React.FC = () => {
  const headquartersSectionRef = React.useRef<HTMLDivElement>(null);
  return (
    <section className="dso_container p_y_md">
      <Typography scale="heading1" scaleMobile="heading3" weight="600" component="h2">Conoce nuestra sede</Typography>

      <HorizontalFoldingSlider
        name="Headquarters"
        data={headquartersItems.map((item) => <HeadquarterItem {...item} />)}
        sectionRef={headquartersSectionRef}
      />
    </section>
  );
};

export default Headquarters;
